<div
    class="cmps-cdk-bg-color-white cmps-cdk-border-color-grey-300 cmps-cdk-border-solid cmps-cdk-border-width-1p cmps-cdk-min-w-512px"
>
    <div class="modal-header">
        <div
            class="modal-title h4"
            role="heading"
            aria-level="1"
        >
            {{ i18n._111_CHANGE_PASSWORD | translate }}
        </div>
        <button
            type="button"
            class="close"
            [attr.aria-label]="i18n._763_CLOSE | translate"
            (click)="_dialogRef.close(false)"
        >
            <cmps-icon svgIcon="close"></cmps-icon>
        </button>
    </div>
    <div class="modal-body">
        <div class="container-fluid">
            <div
                class="row"
                *ngIf="_data?.forced"
            >
                <div class="col-12">
                    <h2>{{ i18n._835_WELCOME_TO_COMPAS_ | translate }}</h2>
                    <p>
                        {{
                            i18n._836_YOU_MUST_CHANGE_YOUR_PASSWORD_BEFORE_PROCEEDING__PLEASE_CREATE_A_NEW_PASSWORD_USING_THE_FORM_BELOW_
                                | translate
                        }}
                    </p>
                </div>
            </div>
            <form
                [name]="form.name"
                #passwordNgForm="ngForm"
            >
                <div class="row">
                    <div class="col-12 form-group">
                        <label>{{
                            form.fields.OLD_PASSWORD.label | translate
                        }}</label>
                        <input
                            type="password"
                            class="form-control"
                            autocomplete="current-password"
                            [name]="form.fields.OLD_PASSWORD.name"
                            [placeholder]="
                                form.fields.OLD_PASSWORD.placeholder | translate
                            "
                            [disabled]="form.submitted"
                            [(ngModel)]="model.old"
                            [field]="form.fields.OLD_PASSWORD"
                        />
                        <div
                            class="alert alert-warning mt-1 mb-0"
                            role="alert"
                            *ngIf="form.errors.OLD_PASSWORD"
                        >
                            {{ form.errors.OLD_PASSWORD }}
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 form-group">
                        <label>{{
                            form.fields.NEW_PASSWORD.label | translate
                        }}</label>
                        <input
                            type="password"
                            class="form-control"
                            autocomplete="new-password"
                            [name]="form.fields.NEW_PASSWORD.name"
                            [placeholder]="
                                form.fields.NEW_PASSWORD.placeholder | translate
                            "
                            [disabled]="form.submitted"
                            [(ngModel)]="model.password"
                            [field]="form.fields.NEW_PASSWORD"
                        />
                        <div
                            class="alert alert-warning mt-1 mb-0"
                            role="alert"
                            *ngIf="form.errors.NEW_PASSWORD"
                        >
                            {{ form.errors.NEW_PASSWORD }}
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 form-group">
                        <label>{{
                            form.fields.NEW_PASSWORD_CONFIRM.label | translate
                        }}</label>
                        <input
                            type="password"
                            class="form-control"
                            autocomplete="new-password"
                            [name]="form.fields.NEW_PASSWORD_CONFIRM.name"
                            [placeholder]="
                                form.fields.NEW_PASSWORD_CONFIRM.placeholder
                                    | translate
                            "
                            [disabled]="form.submitted"
                            [(ngModel)]="model.passwordConfirm"
                            [requiredWhenValidator]="
                                form.fields.NEW_PASSWORD.id
                            "
                            [markAsRequired]="true"
                            [textEqualValidator]="form.fields.NEW_PASSWORD.id"
                            [field]="form.fields.NEW_PASSWORD_CONFIRM"
                        />
                        <div
                            class="alert alert-warning mt-1 mb-0"
                            role="alert"
                            *ngIf="form.errors.NEW_PASSWORD_CONFIRM"
                        >
                            {{ form.errors.NEW_PASSWORD_CONFIRM }}
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div
                            class="alert alert-info"
                            role="alert"
                            *ngIf="form.submitted"
                        >
                            {{ i18n._928_PLEASE_WAIT_ | translate }}
                        </div>
                        <div
                            class="alert alert-warning"
                            role="alert"
                            *ngIf="failure"
                        >
                            <strong>{{
                                i18n._808_PASSWORD_CHANGE_FAILED_ | translate
                            }}</strong>
                            {{ form.serverError }}
                        </div>
                        <div
                            class="alert alert-success"
                            role="alert"
                            *ngIf="success"
                        >
                            <strong>{{
                                i18n._810_PASSWORD_CHANGE_SUCCESSFUL_
                                    | translate
                            }}</strong>
                            {{
                                i18n._811_YOUR_PASSWORD_HAS_CHANGED_ | translate
                            }}
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <div class="modal-footer">
        <ng-container *ngIf="!success; else successTpl">
            <button
                type="button"
                class="btn btn-secondary"
                (click)="_dialogRef.close(false)"
            >
                {{ i18n._121_CANCEL | translate }}
            </button>
            <button
                type="button"
                class="btn btn-primary"
                (click)="onSubmit()"
                [disabled]="form.submitted"
            >
                {{ i18n._111_CHANGE_PASSWORD | translate }}
            </button>
        </ng-container>
        <ng-template #successTpl>
            <button
                type="button"
                class="btn btn-primary"
                (click)="_dialogRef.close(true)"
            >
                {{ i18n._637_OKAY | translate }}
            </button>
        </ng-template>
    </div>
</div>
